import React, { PureComponent } from 'react';
import './Clickable.css';

class Clickable extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            // Whether the clickable is active (i.e. clicked down on)
            active: false,
            // Whether the touch has moved
            // If it has, don't fire onClick (i.e. could have been scrolling or swiped away from clickable)
            touchMoved: false,
            // Whether a touch has been started
            // If true, don't bother firing onClick because touch events are supported
            touched: false,
        }
    }

    render() {
        return (
            <div
                className="ClickableButton"
                style={{
                    transform: 'scale(' + (this.state.active ? '0.85' : '1.0') + ')',
                    transition: 'scale 80ms',
                    transformOrigin: 'center',
                }}
                onTouchStart={() => {
                    this.setState({ active: true, touchMoved: false, touched: true });
                }}
                onTouchMove={() => {
                    this.setState({ touchMoved: true });
                }}
                onTouchEnd={(e) => {
                    e.preventDefault();
                    // Touch did not move, register tap
                    if (!this.state.touchMoved && this.state.touched) {
                        if (typeof this.props.onClick === 'function')
                            this.props.onClick();
                    }
                    this.setState({ active: false, touched: false });
                }}
                onTouchCancel={() => {
                    this.setState({ active: false, touched: false });
                }}
                onMouseDown={() => {
                    this.setState({ active: true });
                }}
                onMouseUp={() => {
                    this.setState({ active: false });
                }}
                onMouseLeave={() => {
                    this.setState({ active: false });
                }}
                onClick={() => {
                    if (!this.state.touched) {
                        if (typeof this.props.onClick === 'function')
                            this.props.onClick();
                    }
                    this.setState({ active: false, touched: false });
                }}
            >
                {this.props.children}
            </div>
        );
    }
}

export default Clickable;
